import comments from './comments';

const root = {
	comments
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js